module.exports = __webpack_public_path__ + "media/components/home/masthead/img/lavakidneys_1680x400@2x-b0846d39f1001d9b1755382e928580a2.jpg";